import BlockDataForm from '@plone/volto/components/manage/Form/BlockDataForm';
import { subjectSchema } from './schema';
import { useIntl } from 'react-intl';

const SubjectData = (props) => {
  const { data, block, onChangeBlock } = props;
  const intl = useIntl();
  const schema = subjectSchema({ ...props, intl });

  return (
    <BlockDataForm
      schema={schema}
      title={schema.title}
      onChangeBlock={onChangeBlock}
      onChangeField={(id, value) => {
        onChangeBlock(block, {
          ...data,
          [id]: value,
        });
      }}
      formData={data}
      block={block}
    />
  );
};

export default SubjectData;
